import Image from 'next/image'
import PropTypes from 'prop-types'

import { isPresent } from 'utils'

import Breadcrumb from 'components/Breadcrumb'
import Header from 'components/Header'
import RichText from 'components/RichText'

import { Description, Main, Root, Title } from './CollectionHeader.style'

const CollectionHeader = ({ title, description, imageUrl }) => {
  return (
    <Root>
      <Main>
        <Title>
          <Header>{title}</Header>
        </Title>
        <Breadcrumb />
        {description && (
          <Description>
            {/* <Text html={description} prose /> */}
            <RichText html={description} prose />
          </Description>
        )}
      </Main>
      {isPresent(imageUrl) && (
        <Image
          src={imageUrl}
          width={600}
          height={400}
          alt=""
          sizes="100vw"
          style={{
            width: '100%',
            height: 'auto',
          }}
        />
      )}
    </Root>
  )
}

CollectionHeader.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  sortBy: PropTypes.oneOf([
    'manual',
    'title|asc',
    'title|asc',
    'price|desc',
    'price|asc',
    'published_at|desc',
    'published_at|asc',
  ]),
  imageUrl: PropTypes.string,
}

CollectionHeader.defaultProps = {
  title: null,
  description: null,
  sortBy: 'manual',
}

export default CollectionHeader
